module.exports = "https://cdn.realtymogul.com/static/media/HP_more_boat.273a7bc6.jpg";